<div class="flex gap-4 w-full h-full pb-6">
  <div class="flex flex-col gap-2 w-full">
    <!-- <div class="flex-col flex gap-4 pb-2 w-full">
      <span class="text-[24px]">Configurator</span>
      <div class="flex gap-6">
        <span>menu</span>
        <span>Customer</span>
      </div>
    </div> -->
    <div class="flex gap-6 h-full w-full">
      <div class="w-72 overflow-clip bg-white h-full rounded-t-xl">
        <div class="flex flex-col">
          <div *ngFor="let item of subMenuItems" class="w-full flex flex-col">
            <button
              [routerLink]="item.route"
              [routerLinkActive]="
                false ? '' : 'bg-primary text-white'
              "
              #rla="routerLinkActive"
              [class]="
                'p-5 items-start flex justify-between ' +
                (item.hasSubMenu && expandedMenuName == item.route
                  ? ' bg-primary text-white'
                  : '')
              "
            >
              <div class="flex items-start gap-2">
                <span>{{ item.name }}</span>
              </div>
              <svg
                width="17"
                height="18"
                viewBox="0 0 17 18"
                fill="inherit"
                [class]="
                  (item.hasSubMenu ? 'stroke-black ' : ' stroke-white ') +
                  ' fill-none ' +
                  (item.hasSubMenu && expandedMenuName == item.route
                    ? 'stroke-white transform rotate-90'
                    : '')
                "
                [routerLinkActive]="
                  item.hasSubMenu && rla.isActive ? '' : 'stroke-white'
                "
              >
                <path
                  d="M6.79083 13.0302L10.8597 8.9613L6.79083 4.8924"
                  stroke="inherit"
                  stroke-width="1.3563"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>

            <!--  -->

            <div
              *ngIf="item.hasSubMenu && rla.isActive"
              class="flex flex-col w-full items-start px-9 gap-6 pt-4 pb-4"
            >
              <button
                *ngFor="let subItem of item.subMenu"
                [routerLink]="
                  '/home/configurator/' + item.route + '/' + subItem.route
                "
                routerLinkActive="text-primary"
              >
                {{ subItem.name }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="w-full overflow-y-auto h-full pb-20">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
